import { Component, Input, OnInit, Output, TemplateRef, ViewChild, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HaloModalSize, HaloModalService } from 'src/app/core/halo-modal/halo-modal';
import { HaloToastService, EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { WorkoutService } from './workout.service';
import { environment } from '../../../../../src/environments/environment';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
@Component({
  selector: 'app-workout',
  templateUrl: './workout.component.html',
  styleUrls: ['./workout.component.scss']
})
export class WorkoutComponent implements OnInit {
  @ViewChild('workoutLibraryTemplate') workoutLibraryTemplate: TemplateRef<any>;
  @ViewChild('workoutListTemplate') workoutListTemplate: TemplateRef<any>;
  @ViewChild('addWorkoutDetailTemplate') addWorkoutDetailTemplate: TemplateRef<any>;
  @ViewChild('addWorkoutDetailActionTemplate') addWorkoutDetailActionTemplate: TemplateRef<any>;
  
  @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
  @ViewChild('bodyTemplate') bodyTemplate: TemplateRef<any>;
  @ViewChild('previewScreenbodyTemplate') previewScreenbodyTemplate: TemplateRef<any>;
  sourceFrom:string;
  selectionInfo: any;
  categoryId: string;
  originalWorkoutList = [] as any;
  workoutList = [] as any;
  workoutObj: any;
  setId: string;
  workoutTemplate: { classicCustomWorkoutsList: [], healthyHeartCustomWorkoutsList: [], performanceCustomWorkoutsList: [], customWorkoutBundleDetails: [] }
  hasEditPermission = false;
  hasNewItem = false;
  haloWebCloudURL: string = environment.haloWebCloudBasePath;
  selectedWorkoutIndex: number;
  selectedWorkoutParentIndex: number;
  remainingInterval:string;
  remainingSeconds = 0;
  intervalParamList:any;
  disabledSaveButton = false;
  defaultCustomWorkoutBundleDetailObject = {
    id: "",
    activityId: "",
    bundleId: "",
    createdAt: "",
    facilityWorkoutId: "",
    orderId: 0,
    updatedAt: "",
    workoutCreatedAt: "",
    workoutDefName: "",
    workoutId: "",
    workoutName: "",
    workoutParamList: [],
    workoutUnit: "",
    workoutUpdatedAt: "",
  }
  forDeleleteWorkout: any;
  showDeleteMsg = false;
  deleteModalProps = {
    title: this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [this.commonUtil.translateText('CUSTOM.WORKOUT')]),
    message: '',
    isWarningPopup: true,
    ctaButtonLabel: 'DELETE',
    negativeButtonLabel: 'CANCEL',
    isCloseIconCallsCta: false,
    isSecondaryTextButton: true,
    hideSecondaryButton: false,
  };
  isActionButtonClicked = false;
  showWorkoutTemplate = false;
  triggerSaveCustomWorkout:boolean;
  private saveAsError = false;
  private saveAsName = '';
  private saveAsLabel = '';
  private saveAsWorkoutObj:any;
  private showPreviewScreenLabel = '';
  private previewScreenWorkoutTemplate:any;
  constructor(
    private commonUtil: CommonUtil,
    private workoutService: WorkoutService,
    private modal: HaloModalService,
    private loader: HaloLoaderService,
    private toast: HaloToastService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private featureService: FeatureFlagsService,
  ) { }

  ngOnInit(): void {
  }

  private onSelectionChange(selectionInfo: SelectionInfo) {
    this.selectionInfo = selectionInfo;
    if(this.selectionInfo.facility.summary?.userRights.customize === 'H'){
      this.commonUtil.redirectToAvailablePage();
    }else{
      this.hasEditPermission = this.selectionInfo.facility.summary?.isLoggedInManagerAdmin === 'true' || this.selectionInfo.facility.summary?.userRights.customize === 'F';
        this.loadWorkOutTemplate();
        this.resetStatus();
    }
  }

  async loadWorkOutTemplate() {
    try{
      let resp: any = await this.workoutService.getWorkoutTemplates(this.selectionInfo.activityId, this.selectionInfo.consoleType, this.selectionInfo.multiFacilities);
      if (resp) {
        this.originalWorkoutList = resp;
        this.workoutList = JSON.parse(JSON.stringify(this.originalWorkoutList));
      }else{
        this.originalWorkoutList = [];
        this.workoutList = [];
      }
      this.showWorkoutTemplate = resp && resp.length>0?true:false;      
    }catch{
      this.originalWorkoutList = [];
      this.workoutList = [];
      this.showWorkoutTemplate = false;
    }    
  }

  addNew() {
    var datePipe = new DatePipe('en-US');
    let defaultNewCustomWorkout : any = {
      buttonName: "",
      id: "-1",
      managerId: "",
      name: `${this.commonUtil.translateText('CUSTOM.WORKOUT')} ${datePipe.transform(Date.now(), 'MMddyyyy_H:mm')}`,
      totalWorkouts: 0,
      updatedAt: "",
      updatedAtTimeStamp: "",
      hasWorkoutChanged: false,
      isEdited: false,
    };

    if(this.selectionInfo.consoleType !== 'discover'){
      defaultNewCustomWorkout.customWorkoutBundleDetails = [
        {
          id: "1",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }, {
          id: "2",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }, {
          id: "3",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }, {
          id: "4",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }, {
          id: "5",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }, {
          id: "6",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }, {
          id: "7",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }, {
          id: "8",
          activityId: "",
          bundleId: "",
          createdAt: "",
          facilityWorkoutId: "",
          orderId: "",
          updatedAt: "",
          workoutCreatedAt: "",
          workoutDefName: "",
          workoutId: "",
          workoutName: "",
          workoutParamList: [],
          workoutUnit: "",
          workoutUpdatedAt: "",
        }
      ]
    }else{
      defaultNewCustomWorkout.classicCustomWorkoutsList = [{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '1', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      },{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '2', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      },{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '3', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      }];
      defaultNewCustomWorkout.healthyHeartCustomWorkoutsList = [{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '1', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      },{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '2', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      },{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '3', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      }];
      defaultNewCustomWorkout.performanceCustomWorkoutsList = [{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '1', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      },{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '2', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      },{
        activityId: '', bundleId: '', createdAt: '',
        facilityWorkoutId: '', orderId: '', updatedAt: '', workoutCreatedAt: '', workoutDefName: ''
        , workoutId: '3', workoutName: '', workoutParamList: [], workoutUnit: '', workoutUpdatedAt: ''
      }];
    }
    this.hasNewItem = true;
    this.setId = defaultNewCustomWorkout.id;
    this.showWorkoutTemplate = true;
    this.workoutList.unshift(JSON.parse(JSON.stringify(defaultNewCustomWorkout)));
    this.originalWorkoutList.unshift(JSON.parse(JSON.stringify(defaultNewCustomWorkout)));
    // show newly added item
    setTimeout(() => {
      //@ts-ignore
      $('#collapse-1').collapse('show');
    }, 100);
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  showWorkOutLibrary(idx: number, parentIdx: number,categoryId:string) {
    if(this.hasEditPermission){
      this.selectedWorkoutIndex = idx;
      this.selectedWorkoutParentIndex = parentIdx;    
      this.selectionInfo.categoryId = categoryId;
      this.modal.add({
        dismissible: true,
        titleUppercase: true,
        modalSize: HaloModalSize.Large,
        onDismiss: this.onDismiss,
        title: this.workoutService.getEquipmentDisplayNameByEquipmentTypeId(this.selectionInfo.activityId) + " " + this.commonUtil.translateText('WORKOUT.LIBRARY'),
        bodyTemplate: this.workoutLibraryTemplate,
        isVideoTree: false
      });
    } 
  }

  onBackToWorkoutListingEventEmit(){
    this.triggerSaveCustomWorkout = false;
    this.modal.close();
    this.showWorkOutLibrary(this.selectedWorkoutIndex,this.selectedWorkoutParentIndex,this.selectionInfo.categoryId);
  }

  onBackToWorkoutTemplateListingEventEmit(data:any){
    this.triggerSaveCustomWorkout = false;
    this.modal.close();
    this.updateWorkoutListInWorkoutTemplate(data);
    this.resetStatus();
  }

  updateWorkoutListInWorkoutTemplate(data:any){
    if(this.selectionInfo.consoleType === 'discover'){      
      if(this.selectionInfo.categoryId === '0'){
        this.workoutList[this.selectedWorkoutParentIndex].classicCustomWorkoutsList.forEach((val:any) => {
          if(val.workoutId === data.workoutId && val.facilityWorkoutId === data.facilityWorkoutId){
            val.workoutName = data.workoutName;
            val.workoutParamList= data.workoutParamList;
          }
        });
        this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts += this.workoutList[this.selectedWorkoutParentIndex].classicCustomWorkoutsList.filter((val:any) => val.facilityWorkoutId  !== "").length;
      }else if(this.selectionInfo.categoryId === '1'){
        this.workoutList[this.selectedWorkoutParentIndex].healthyHeartCustomWorkoutsList.forEach((val:any) => {
          if(val.workoutId === data.workoutId && val.facilityWorkoutId === data.facilityWorkoutId){
            val.workoutName = data.workoutName;
            val.workoutParamList= data.workoutParamList;
          }
        });
        this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts += this.workoutList[this.selectedWorkoutParentIndex].healthyHeartCustomWorkoutsList.filter((val:any) => val.facilityWorkoutId  !== "").length;
      }else if(this.selectionInfo.categoryId === '2'){
        this.workoutList[this.selectedWorkoutParentIndex].performanceCustomWorkoutsList.forEach((val:any) => {
          if(val.workoutId === data.workoutId && val.facilityWorkoutId === data.facilityWorkoutId){
            val.workoutName = data.workoutName;
            val.workoutParamList= data.workoutParamList;
          }
        });
        this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts += this.workoutList[this.selectedWorkoutParentIndex].performanceCustomWorkoutsList.filter((val:any) => val.facilityWorkoutId  !== "").length;
      }      
      this.workoutList[this.selectedWorkoutParentIndex].isEdited = true;      
    }else{      
      this.workoutList[this.selectedWorkoutParentIndex].customWorkoutBundleDetails.forEach((val:any) => {
        if(val.workoutId === data.workoutId && val.facilityWorkoutId === data.facilityWorkoutId){
          val.workoutName = data.workoutName;
          val.workoutParamList= data.workoutParamList;
        }
      })            
      this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts = this.workoutList[this.selectedWorkoutParentIndex].customWorkoutBundleDetails.filter((val:any) => val.facilityWorkoutId  !== "").length;
      this.workoutList[this.selectedWorkoutParentIndex].isEdited = true;
    } 
  }

  onCreatNewWorkoutEventEmit(status: boolean) {
    // Dismiss WorkOutLibrary Modal and trigger the WorkOutList Modal to create new workout template.
    this.modal.close();
    this.showWorkOutList("-1");
  }

  onAddWorkoutLibraryEventEmit(workoutLibrary: any) {
    // Dismiss WorkOutLibrary Modal and trigger the WorkOutList Modal to create new workout template.
    this.modal.close();
    let selectedWorkOutLibrary = {
      activityId: this.selectionInfo.activityId,
      categoryId:workoutLibrary.categoryId,
      bundleId: Number(this.workoutList[this.selectedWorkoutParentIndex].id),
      facilityWorkoutId: workoutLibrary.id,
      id: workoutLibrary.id,
      orderId: this.selectedWorkoutIndex,
      workoutDefName: workoutLibrary.workoutDefName,
      workoutId: workoutLibrary.workoutId,
      workoutName: workoutLibrary.workoutName,
      workoutParamList: workoutLibrary.workoutParamList,
      hasWorkoutChanged: true
    } as any;

    if(workoutLibrary.intervalId){
      selectedWorkOutLibrary['intervalId'] = workoutLibrary.intervalId;
    }    

    if(this.selectionInfo.consoleType === 'discover'){      
      if(this.selectionInfo.categoryId === '0'){
        this.workoutList[this.selectedWorkoutParentIndex].classicCustomWorkoutsList[this.selectedWorkoutIndex] = selectedWorkOutLibrary;
        this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts += this.workoutList[this.selectedWorkoutParentIndex].classicCustomWorkoutsList.filter((val:any) => val.facilityWorkoutId  !== "").length;
      }else if(this.selectionInfo.categoryId === '1'){
        this.workoutList[this.selectedWorkoutParentIndex].healthyHeartCustomWorkoutsList[this.selectedWorkoutIndex] = selectedWorkOutLibrary;
        this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts += this.workoutList[this.selectedWorkoutParentIndex].healthyHeartCustomWorkoutsList.filter((val:any) => val.facilityWorkoutId  !== "").length;
      }else if(this.selectionInfo.categoryId === '2'){
        this.workoutList[this.selectedWorkoutParentIndex].performanceCustomWorkoutsList[this.selectedWorkoutIndex] = selectedWorkOutLibrary;
        this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts += this.workoutList[this.selectedWorkoutParentIndex].performanceCustomWorkoutsList.filter((val:any) => val.facilityWorkoutId  !== "").length;
      }      
      this.workoutList[this.selectedWorkoutParentIndex].isEdited = true;      
    }else{      
      this.workoutList[this.selectedWorkoutParentIndex].customWorkoutBundleDetails[this.selectedWorkoutIndex] = selectedWorkOutLibrary;
      this.workoutList[this.selectedWorkoutParentIndex].isEdited = true;
      this.workoutList[this.selectedWorkoutParentIndex].totalWorkouts = this.workoutList[this.selectedWorkoutParentIndex].customWorkoutBundleDetails.filter((val:any) => val.facilityWorkoutId  !== "").length;
    }         
  }

  onWorkOutActionButtonClick(action: string, idx: number, parentIdx: number,workout :any,workoutType: any,categoryId:any) {
    this.selectionInfo.categoryId = categoryId;
    this.selectedWorkoutParentIndex = parentIdx;
    if (action === 'EDIT') {
      let workoutDetails:any;
      if(workoutType === 'classicCustomWorkouts'){
        workoutDetails = this.workoutList[parentIdx].classicCustomWorkoutsList[idx];
      }else if(workoutType === 'healthyHeartCustomWorkouts'){
        workoutDetails = this.workoutList[parentIdx].healthyHeartCustomWorkoutsList[idx];
      }else if(workoutType === 'performanceCustomWorkouts'){
        workoutDetails = this.workoutList[parentIdx].performanceCustomWorkoutsList[idx];
      }else{
        workoutDetails = this.workoutList[parentIdx].customWorkoutBundleDetails[idx];
      }      
      this.onSelectWorkOutListEventEmit(workoutDetails,'workoutTemplate');      
    } else {
      //REMOVE SELECTED WORKOUT.
      if(workoutType === 'classicCustomWorkouts'){
        this.workoutList[parentIdx].classicCustomWorkoutsList[idx] = this.defaultCustomWorkoutBundleDetailObject;   
      }else if(workoutType === 'healthyHeartCustomWorkouts'){       
        this.workoutList[parentIdx].healthyHeartCustomWorkoutsList[idx] = this.defaultCustomWorkoutBundleDetailObject;
      }else if(workoutType === 'performanceCustomWorkouts'){
        this.workoutList[parentIdx].performanceCustomWorkoutsList[idx] = this.defaultCustomWorkoutBundleDetailObject;      
      }else{
        this.defaultCustomWorkoutBundleDetailObject.id = this.workoutList[parentIdx].customWorkoutBundleDetails[idx].id;
        this.defaultCustomWorkoutBundleDetailObject.orderId = idx;
        this.workoutList[parentIdx].customWorkoutBundleDetails[idx] = this.defaultCustomWorkoutBundleDetailObject;
      }     
      this.workoutList[parentIdx].totalWorkouts += -1;
    }
    workout.isEdited = true;
  }

  processDelete(workout: any) {
    this.forDeleleteWorkout = workout;
    this.showDeleteMsg = true;
    if (workout.inUse) {
      this.deleteModalProps.message = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.PUBLISHED.MODAL.MESSAGE', [this.commonUtil.translateText('CUSTOM.WORKOUT')]);
    } else {
      this.deleteModalProps.message = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.MODAL.MESSAGE', [this.commonUtil.translateText('CUSTOM.WORKOUT')]);
    }
  }

  async confirmDelete() {
    if (this.forDeleleteWorkout && this.forDeleleteWorkout.id !== '-1') {
      try {
        this.loader.startProcess();
        this._amplitudeAnalytics.logEvent({elementName: 'Delete', action: "Click"});
        await this.workoutService.deleteWorkoutTemplate(this.forDeleleteWorkout.id);
        this.toast.creatToast(
          this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETED.SUCCESS.MSG', [this.forDeleleteWorkout.name]),
          EToastType.SUCCESS
        );
        this.loadWorkOutTemplate();
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
      } catch (error) {
        console.error('API error.');
      }
      finally {
        this.loader.endProcess();
        this.resetStatus();
      }
    } else {
      this.loader.startProcess();
      this.loadWorkOutTemplate();
      this.loader.endProcess();
      this.resetStatus();
    }
  }

  resetStatus() {
    this.isActionButtonClicked = false;
    this.forDeleleteWorkout = null;
    this.showDeleteMsg = false;
    this.hasNewItem = false;
    this.setId = '';
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
  }

  showWorkOutList(categoryId: string) {
    this.selectionInfo.categoryId = this.selectionInfo.categoryId?this.selectionInfo.categoryId:'-1';
    this.modal.add({
      dismissible: true,
      titleUppercase: true,
      modalSize: HaloModalSize.Large,
      onDismiss: this.onDismiss,
      title: this.workoutService.getEquipmentDisplayNameByEquipmentTypeId(this.selectionInfo.activityId) + " " + this.commonUtil.translateText('WORKOUT.LIST'),
      bodyTemplate: this.workoutListTemplate,
      isVideoTree: false
    });
  }

  showAddWorkoutDetail(workoutObj: any,sourceFrom:string) {
    this.sourceFrom = sourceFrom;
    this.workoutObj = workoutObj;
    this.selectionInfo.categoryId = this.selectionInfo.categoryId?this.selectionInfo.categoryId:'-1';
    let title = this.workoutService.getEquipmentDisplayNameByEquipmentTypeId(this.selectionInfo.activityId) + " " + 
    (this.workoutObj.facilityWorkoutId ? this.commonUtil.translateText('EDIT.WORKOUT') :this.commonUtil.translateText('NEW.WORKOUT')) + 
    "(" + (this.workoutObj.facilityWorkoutId?workoutObj.workoutDefName:workoutObj.workoutName.userPreferredLanguage) + ")";
    
    this.modal.add({
      dismissible: true,
      titleUppercase: true,
      modalSize: (this.workoutObj.workoutId==18 || this.workoutObj.workoutId==19 || this.workoutObj.workoutId==20 || this.workoutObj.workoutId == 1005 || this.workoutObj.workoutId == 1011)?HaloModalSize.Large:HaloModalSize.Small,
      onDismiss: this.onDismiss,
      title: title,
      bodyTemplate: this.addWorkoutDetailTemplate,
      footerTemplate: this.addWorkoutDetailActionTemplate,
      isVideoTree: false
    });
  }

  onBackToWorkoutListing(){
    this.triggerSaveCustomWorkout = false;
    // Dismiss WorkOutLibrary Modal and trigger the WorkOutList Modal to create new workout template.
    this.modal.close();
    this.showWorkOutList("-1");
  }

  onTriggerSaveCustomWorkout(){
    this.triggerSaveCustomWorkout = false;
    setTimeout(() => {
      this.triggerSaveCustomWorkout = true;
    }, 1000);
    
  }

  onSelectWorkOutListEventEmit(workoutObj: any, source:string) {
    // Dismiss WorkOutLibrary Modal and trigger the WorkOutList Modal to create new workout template.
    this.modal.close();
    workoutObj.activityId = workoutObj.activityId?workoutObj.activityId:this.selectionInfo.activityId;
    this.showAddWorkoutDetail(workoutObj,source);
  }

  onToggleCollapse(event: any, setId: string) {
    this.setId = setId;
    var expanded = event.target.getAttribute('aria-expanded');
    if (expanded === 'true') {
      this.setId = '';
    }
  }

  undoAll(curUpdatedWorkout: any, parentIdx: string){
    this.workoutList[parentIdx] =  JSON.parse(JSON.stringify(this.originalWorkoutList[parentIdx]));
    this.setId = curUpdatedWorkout.id;
    this.isActionButtonClicked = false;
    setTimeout(val => {
      let element = document.getElementById('collapse'+curUpdatedWorkout.id);
      element?.classList.add('show');
    },1000)
  }

  saveAs(workout:any,parentIdx:any){
    if(workout.id == "-1"){
      this.hasNewItem = false;
    }
    this.showSaveAsModalDialog();
    this.saveAsWorkoutObj = JSON.parse(JSON.stringify(workout));
  }

  showSaveAsModalDialog() {
    this.modal.add({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Medium,
      title: this.commonUtil.translateText('SAVEAS'),
      bodyTemplate: this.bodyTemplate,
      footerTemplate: this.actionTemplate
    });
    this.saveAsLabel = this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.NEW.NAME', [this.commonUtil.translateText('CUSTOM.WORKOUT')]);
  }

  async save(workout: any, parentIdx: string) {
    this.isActionButtonClicked = true;
    if(!this.isValidWorkoutTemplate(workout)){
      return;
    }
    try {
      this.loader.startProcess();
      let payload : any = { 
        activityId: this.selectionInfo.activityId, 
        buttonName: workout.buttonName, 
        consoleType: this.selectionInfo.consoleType, 
        id: workout.id, 
        managerId: workout.managerId, 
        name: workout.name, 
        updatedAt: workout.updatedAt, 
        updatedAtTimeStamp: workout.updatedAtTimeStamp
      };
      if(this.selectionInfo.consoleType !== 'discover'){
        payload.customWorkoutBundleDetails = workout.customWorkoutBundleDetails.filter((val: any) => val.activityId);
      }else{
        let  tmpWkList_1 = workout.classicCustomWorkoutsList.filter((val: any) => val.activityId);
        if(tmpWkList_1.length>0){
          payload.classicCustomWorkoutsList = tmpWkList_1;
        }

        let  tmpWkList_2 = workout.healthyHeartCustomWorkoutsList.filter((val: any) => val.activityId);
        if(tmpWkList_2.length>0){
          payload.healthyHeartCustomWorkoutsList = tmpWkList_2;
        }

        let  tmpWkList_3 = workout.performanceCustomWorkoutsList.filter((val: any) => val.activityId);
        if(tmpWkList_3.length>0){
          payload.performanceCustomWorkoutsList = tmpWkList_3;
        }
      }
      let resp: any = await this.workoutService.saveWorkOutTemplates(payload);
      this.updateWorkoutObjectAfterSaved(resp,'save',workout.id,parentIdx);
      if (workout.id === '-1') {
        this.hasNewItem = false;
        this.isActionButtonClicked = false;
      }
      this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.SAVED.SUCCESSFULLY', [resp.name]), EToastType.SUCCESS);
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = this.workoutList.some((a: any) => a.isEdited);
    } catch (error) {
      console.error('API error.');
    }
    finally {
      this.loader.endProcess();
    }
  }

  onRemainingTimeEventEmit(obj:any){
    let minTimeSec = obj.formControls.goalTypeControls[0].minValue * 60;
    let minutes = Math.floor(obj.totalRemainingIntervalSec / 60);
		let seconds = obj.totalRemainingIntervalSec - minutes * 60;
    this.remainingInterval = minutes+" Min "+seconds+" Sec";
    this.remainingSeconds = obj.totalRemainingIntervalSec;
    if(obj.totalAppliedIntervalSec >= minTimeSec 
      && (this.workoutObj.workoutId==18 || this.workoutObj.workoutId==19 || this.workoutObj.workoutId==20 ||  this.workoutObj.workoutId==1005 ||  this.workoutObj.workoutId==1011)){        
      this.disabledSaveButton = false;      
    } else {
      this.disabledSaveButton = true;      
    }   
  }

  onintervalParamListEventEmit(intervalParamList:any){
    this.intervalParamList = intervalParamList;    
  }

  async onSaveAsTrigger() {
    if(this.saveAsName.trim() === ''){
      this.saveAsError = true;
    }else{
      this.saveAsError = false;
      try {
        this.loader.startProcess();
        let payload : any = { activityId: this.selectionInfo.activityId, 
          buttonName: this.saveAsWorkoutObj.buttonName, 
          consoleType: this.selectionInfo.consoleType, 
          id: null, 
          managerId: this.saveAsWorkoutObj.managerId, 
          name: this.saveAsName, 
          updatedAt: this.saveAsWorkoutObj.updatedAt, 
          updatedAtTimeStamp: this.saveAsWorkoutObj.updatedAtTimeStamp 
        };
        if(this.selectionInfo.consoleType !== 'discover'){
          payload.customWorkoutBundleDetails = this.saveAsWorkoutObj.customWorkoutBundleDetails.filter((val: any) => val.activityId);
        }else{
          let  tmpWkList_1 = this.saveAsWorkoutObj.classicCustomWorkoutsList.filter((val: any) => val.activityId);
          if(tmpWkList_1.length>0){
            payload.classicCustomWorkoutsList = tmpWkList_1;
          }

          let  tmpWkList_2 = this.saveAsWorkoutObj.healthyHeartCustomWorkoutsList.filter((val: any) => val.activityId);
          if(tmpWkList_2.length>0){
            payload.healthyHeartCustomWorkoutsList = tmpWkList_2;
          }

          let  tmpWkList_3 = this.saveAsWorkoutObj.performanceCustomWorkoutsList.filter((val: any) => val.activityId);
          if(tmpWkList_3.length>0){
            payload.performanceCustomWorkoutsList = tmpWkList_3;
          }
        }
        let resp: any = await this.workoutService.saveWorkOutTemplates(payload);
        this.updateWorkoutObjectAfterSaved(resp,'saveAs',this.saveAsWorkoutObj.id,null);
        this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.SAVED.SUCCESSFULLY', [resp.name]), EToastType.SUCCESS);
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = this.workoutList.some((a: any) => a.isEdited);
      } catch (error) {
        console.error('API error.');
      }
      finally {
        this.modal.close();
        this.loader.endProcess();
      }
    } 
  }

  onSaveAsCancel() {
    this.saveAsName = '';
    this.saveAsWorkoutObj=null;
    this.disabledSaveButton = false;
    this.modal.close();
  }

  async publish(workout: any) {
    this.isActionButtonClicked = true;
    if(!this.isValidWorkoutTemplate(workout)){
      return;
    }
    let payload: any;
    payload = {
      activityId: Number(this.selectionInfo.activityId),
      buttonName: workout.buttonName,
      consoleType: this.selectionInfo.consoleType,     
      facilityIds: this.selectionInfo.facility.facilityId.split(','),
      id: workout.id === "-1" ? null : workout.id,
      name: workout.name,
    }

    if(this.selectionInfo.consoleType !== 'discover'){
      payload.customWorkoutBundleDetails = workout.customWorkoutBundleDetails.filter((val: any) => val.facilityWorkoutId !== "").map((u: any, index: any) => (
        {
          activityId: u.activityId,
          bundleId: u.bundleId,
          facilityWorkoutId: u.facilityWorkoutId,
          id: u.id,
          orderId: index,
          workoutDefName: u.workoutDefName,
          workoutId: u.workoutId,
          workoutName: u.workoutName,
          workoutParamList: u.workoutParamList
        }
      ));
    }else{
      let tmpWkList_1 = workout.classicCustomWorkoutsList.filter((val: any) => val.facilityWorkoutId !== "");
      if(tmpWkList_1.length>0){
        payload.classicCustomWorkoutsList = tmpWkList_1;
      }
      let tmpWkList_2 = workout.healthyHeartCustomWorkoutsList.filter((val: any) => val.facilityWorkoutId !== "");
      if(tmpWkList_2.length>0){
        payload.healthyHeartCustomWorkoutsList = tmpWkList_2;
      }
      let tmpWkList_3 = workout.performanceCustomWorkoutsList.filter((val: any) => val.facilityWorkoutId !== "");
      if(tmpWkList_3.length>0){
        payload.performanceCustomWorkoutsList = tmpWkList_3;
      }      
    }

    if (workout.id !== "-1") {
        payload.managerId = workout.managerId,
        payload.publishedDt = workout.publishedDt,
        payload.publishedDtTimeStamp = workout.publishedDtTimeStamp,
        payload.updatedAt = workout.updatedAt,
        payload.updatedAtTimeStamp = workout.updatedAtTimeStamp
    };
    try {
      this.loader.startProcess();
      let resp: any = await this.workoutService.publishWorkoutTemplates(payload);
      this.loadWorkOutTemplate();
      this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('GENERIC.PUBLISHED.SUCCESSFULLY', [payload.name ? payload.name : '']), EToastType.SUCCESS);
    } catch (error) {
      console.error('API error.');
    }
    finally {
      this.loader.endProcess();
      this.resetStatus();
    }
  }

  async showPreviewScreen(workoutTemplate:any){
    this.modal.add({
      dismissible: true,
      titleUppercase: true,      
      modalSize: HaloModalSize.Large,
      title: this.commonUtil.translateText('VIEW.ON.CONSOLE').toUpperCase(),
      bodyTemplate: this.previewScreenbodyTemplate
    });
    this.showPreviewScreenLabel = this.commonUtil.translateText('FACILITY.WORKOUTS');
    this.previewScreenWorkoutTemplate = workoutTemplate;
  }

  isValidWorkoutTemplate(workout:any){
    let status = false;
    if(this.selectionInfo.consoleType !== 'discover'){
      if(workout.name && workout.buttonName && workout.customWorkoutBundleDetails.filter((val: any) => val.activityId).length>0){
        status = true;
      }else{
        status = false;
      }
    }else{
      if(workout.name && (workout.classicCustomWorkoutsList.filter((val: any) => val.activityId).length>0 || workout.performanceCustomWorkoutsList.filter((val: any) => val.activityId).length>0 || workout.healthyHeartCustomWorkoutsList.filter((val: any) => val.activityId).length>0)){
        status = true;
      } else {
        status = false;
      }      
    }
   return status;
  }

  inputKeyup(workout:any,parentIdx:number){
    this.selectedWorkoutParentIndex = parentIdx;
    workout.isEdited = true;
  }

  updateWorkoutObjectAfterSaved(curUpdatedWorkout:any,source:string,selectedWorkoutId:string,parentIdx?:any){
    let workoutData = this.workoutService.prepareWorkoutTemplate({customWorkoutBundlesList:[curUpdatedWorkout]},this.selectionInfo.consoleType);
    if(source === 'save'){
      this.workoutList[parentIdx] = JSON.parse(JSON.stringify(workoutData[0]));
      this.originalWorkoutList[parentIdx] = JSON.parse(JSON.stringify(workoutData[0]));
      this.setId = workoutData[0].id;
      setTimeout(val => {
        let element = document.getElementById('collapse'+workoutData[0].id);
        element?.classList.add('show');
      },1000)
    }else if(source === 'saveAs'){
      this.workoutList.unshift(JSON.parse(JSON.stringify(workoutData[0])));
      this.originalWorkoutList.unshift(JSON.parse(JSON.stringify(workoutData[0])));
      this.setId = workoutData[0].id;
      setTimeout(val => {
        let selectedAnnouncementElement = document.getElementById('collapse'+selectedWorkoutId);
        selectedAnnouncementElement?.classList.remove('show');
        let element = document.getElementById('collapse'+workoutData[0].id);
        element?.classList.add('show');
      },1000)
    }
  }

  isSe4Console() {
		let status = false;
    const consoles = ['hal', 'everest', 'neo_se4', 'falco']
		if(consoles.some(c => this.selectionInfo.consoleType.includes(c))) {
			status = true;
		}
		return status;
	}
 
  onDismiss() {
    //...
  }

  onResetActionButtonEventEmit(){
    this.disabledSaveButton = false;
  }
}
